"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  shouldWidgetOpenAbove: true,
  scrollIntoView: true
};
exports.shouldWidgetOpenAbove = exports.scrollIntoView = void 0;
var _ScrollEvents = require("./windowEvents/ScrollEvents");
Object.keys(_ScrollEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ScrollEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScrollEvents[key];
    }
  });
});
var _ResizeEvents = require("./windowEvents/ResizeEvents");
Object.keys(_ResizeEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ResizeEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ResizeEvents[key];
    }
  });
});
var shouldWidgetOpenAbove = function shouldWidgetOpenAbove(element) {
  return element.getBoundingClientRect().bottom / window.innerHeight > 0.6;
};
exports.shouldWidgetOpenAbove = shouldWidgetOpenAbove;
var scrollIntoView = function scrollIntoView(element) {
  var stickyElementsHeight = (0, _ScrollEvents.getStickyElements)().map(function (item) {
    return item.elm;
  }).filter(function (elm) {
    return window.getComputedStyle(elm).visibility !== "hidden";
  }).map(function (elm) {
    return elm.offsetHeight;
  }).reduce(function (result, current) {
    return result + current;
  }, 0);
  var scrollPos = element.offsetTop - stickyElementsHeight;
  window.scroll({
    behavior: "smooth",
    top: scrollPos
  });
};
exports.scrollIntoView = scrollIntoView;